/* eslint-disable import/no-duplicates */
/* eslint-disable react/destructuring-assignment */

import { ReactNode } from 'react';
import * as React from 'react';

import styles from './infoGroup.module.scss';

export interface InfoGroupRowData {
  name: string;
  subRows: ReactNode[];
}

interface InfoGroupProps {
  title: string;
  data: InfoGroupRowData[];
}

export default class InfoGroup extends React.Component<InfoGroupProps> {
  private static renderRow(row: InfoGroupRowData) {
    return (
      <div key={row.name} className={styles.infoRow}>
        <span className={styles.label}>{row.name}</span>
        <span className={styles.values}>
          {row.subRows.map((sr, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={index}>{sr}</div>
          ))}
        </span>
      </div>
    );
  }

  public render() {
    return (
      <div className={styles.infoGroup}>
        <div className={styles.title}>{this.props.title}</div>
        {this.props.data.map(row => InfoGroup.renderRow(row))}
      </div>
    );
  }
}
